import { render, staticRenderFns } from "./organizationManage.vue?vue&type=template&id=13113c45&scoped=true"
import script from "./organizationManage.vue?vue&type=script&lang=js"
export * from "./organizationManage.vue?vue&type=script&lang=js"
import style0 from "./organizationManage.vue?vue&type=style&index=0&id=13113c45&lang=css"
import style1 from "./organizationManage.vue?vue&type=style&index=1&id=13113c45&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13113c45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13113c45')) {
      api.createRecord('13113c45', component.options)
    } else {
      api.reload('13113c45', component.options)
    }
    module.hot.accept("./organizationManage.vue?vue&type=template&id=13113c45&scoped=true", function () {
      api.rerender('13113c45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/organizationManage/organizationManage.vue"
export default component.exports